export const results = [
  {
    English: [
      "Results",
      "Total Questions",
      "Correctly Answered",
      "Incorrectly Answered",
      "Maximum Score",
      "Your Score",
      "Try Again",
      "Other test",
    ],
    Ukrainian: [
      "Результати",
      "Усього запитань",
      "Правильних відповідей",
      "Неправильних відповідей",
      "Максимальний бал",
      "Набрано Балів",
      "Спробувати ще раз",
      "Інший тест",
    ],
    Polish: [
      "Wyniki",
      "Całkowita liczba pytań",
      "Poprawnie odpowiedziano",
      "Niepoprawnie odpowiedziano",
      "Maksymalny wynik",
      "Wynik",
      "Spróbuj ponownie",
      "Inny test",
    ],
    German: [
      "Ergebnisse",
      "Gesamtzahl der Fragen",
      "Richtig beantwortet",
      "Falsch beantwortet",
      "Maximaler Punktestand",
      "Ergebnis",
      "Versuch es nochmal",
      "Anderer Test",
    ],
  },
];
